import { render, staticRenderFns } from "./MemberHeaderNav.vue?vue&type=template&id=507528b3&"
import script from "./MemberHeaderNav.vue?vue&type=script&lang=js&"
export * from "./MemberHeaderNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports